import { createContext, useContext } from 'react';

import type {
  Menu,
  Page,
  Product,
} from '@frontend/storefront/lib/shopify/types';

export type StorefrontData = {
  path: string;
  title: string;
  description: string;
  menus: { 'main-menu': Menu[]; footer: Menu[] };
  products?: Product[];
  product?: Product;
  page?: Page;
  notFound?: boolean;
};
export const StorefrontDataContext = createContext<StorefrontData | null>(null);
export function useStorefrontData() {
  const value = useContext(StorefrontDataContext);
  if (!value) throw new Error('Storefront data is missing');
  return value;
}
